import styled from 'styled-components'

import { gray, lightGray } from '../../../styles/themeColors'

export const AddOnsSelectContainer = styled.div`
  & button {
    align-items: center;
    display: flex;
    border-color: ${lightGray};
    border-radius: 35px;
    color: ${gray};
    padding: 10px 18px;
  }
  *:focus,
  *:hover {
    background-color: white !important;
    color: ${gray} !important;
    outline: none !important;
  }
`

export const FreeGuestCTAContainer = styled.div`
  margin-top: 10px;
  position: relative;
  width: fit-content;
  .cta-free-guest {
    margin-bottom: 1rem !important;
  }
  .arrow-left {
    position: absolute;
    right: 25px;
    transform: rotate(-100deg);
    top: 15px;
    width: fit-content;
    img {
      height: 30px;
      transform: scaleY(-1);
      width: 30px;
    }
  }
`
